export default __webpack_public_path__ + "static/media/add-groups.02dbf6a8.svg";